
export default {
    searchBanners(params) {
        let path = process.env.apiPath + '/publisher/banners.search';
        params = params || {};
        params.fields = 'banner.locales,banner.mime_type,banner.dimensions,banner.width,banner.height';
        return this.makeRequest(path, params);
    },

    searchBannerLocales(params) {
        let path = process.env.apiPath + '/publisher/banners.getLocales';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchBannerDimensions(params) {
        let path = process.env.apiPath + '/publisher/banners.getDimensions';
        params = params || {};
        return this.makeRequest(path, params);
    },

    searchBannerMimeTypes(params) {
        let path = process.env.apiPath + '/publisher/banners.getMimeTypes';
        params = params || {};
        return this.makeRequest(path, params);
    },

    saveBannerPresets(params) {
        let path = process.env.apiPath + '/publisher/banners.savePresets';
        params = params || {};
        return this.makeRequest(path, params);
    }
};